"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/VariableHeaders.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _MenuItem = require('web/screens/Broadcast/MenuItem'); var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _useMenuButton = require('web/screens/Broadcast/useMenuButton'); var _useMenuButton2 = _interopRequireDefault(_useMenuButton);













/* Rev 31 v2 frame 7b: a variable's header opens Edit variable… and Remove
 * variable (disabled, with the reason, while the message uses it). */
const HeaderMenu




 = ({ column, onEdit, onRemove, disabledReason }) => {
  const menu = _useMenuButton2.default.call(void 0, )
  const choose = (act) => () => {
    menu.close()
    act(column)
  }
  return (
    _react2.default.createElement('div', { ref: menu.rootRef, className: "recipients-variable-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
      , _react2.default.createElement('button', { ...menu.triggerProps, type: "button", className: "recipients-variable-head--button", 'aria-label': column.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
        ,  column.name 
        , _react2.default.createElement('span', { className: "recipients-variable-head--caret", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "▾")
      )
      ,  menu.isOpen && (
        _react2.default.createElement('div', { ...menu.menuProps, 'aria-label': column.name, className: "broadcast-menu recipients-variable-head--menu" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
          , _react2.default.createElement(_MenuItem2.default, {
            label: "Edit variable…" ,
            desc: _nullishCoalesce(disabledReason, () => ( 'Name and default value')),
            iconSrc: "/assets/icons/header/edit-dark.svg",
            disabled: !!disabledReason,
            onClick: choose(onEdit), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
          )
          , _react2.default.createElement(_MenuItem2.default, {
            label: "Remove variable" ,
            desc: _nullishCoalesce(disabledReason, () => ( (column.isUsed ? 'The message uses it' : "Only if the message doesn't use it"))),
            iconSrc: "/assets/icons/broadcast/remove.svg",
            isDestructive: true,
            disabled: column.isUsed || !!disabledReason,
            onClick: choose(onRemove), __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
          )
        )
      )
    )
  )
}

/* The variable columns' headers, after Status (Q1). */
const VariableHeaders = ({ columns, onMoveColumn, onEdit, onRemove, disabledReason = null }) => {
  const [dragged, setDragged] = _react.useState(null)
  const [over, setOver] = _react.useState(null)
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  columns.map(c => (
        _react2.default.createElement('th', {
          key: c.name,
          draggable: true,
          title: "Drag to reorder"  ,
          onDragStart: e => {
            setDragged(c.name)
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData('text/plain', c.name)
          },
          onDragOver: e => { if (dragged) { e.preventDefault(); setOver(c.name) } },
          onDragLeave: () => setOver(o => o === c.name ? null : o),
          onDrop: e => {
            e.preventDefault()
            if (dragged) onMoveColumn(dragged, c.name)
            setDragged(null)
            setOver(null)
          },
          onDragEnd: () => { setDragged(null); setOver(null) },
          className: _classBuilder2.default.call(void 0, 
            'campaign--table--col-variable',
            'campaign--table--col-variable--draggable',
            over === c.name && dragged !== c.name && 'campaign--table--col-variable--over',
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}

          ,  onEdit && onRemove ? _react2.default.createElement(HeaderMenu, { column: c, onEdit: onEdit, onRemove: onRemove, disabledReason: disabledReason, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}} ) : c.name 
        )
      ))
    )
  )
}

exports. default = VariableHeaders
